import { Component } from '@angular/core';

@Component({
  selector: 'app-forbidden',
  template: `
    <h1>Access denied</h1>
    <p>You do not have permission to use this application.</p>
  `
})
export class ForbiddenComponent { }
